import {
  SmartInsightsRoute,
  SmartInsightsPathName,
} from '@/modules/ta/smartinsights/smartinsights.constants';
import { SmartInsightsRouteConfig } from '@/modules/ta/smartinsights/SmartInsightsRouteConfig';

export const router = SmartInsightsRouteConfig.factory([
  {
    path: `/${SmartInsightsRoute.SMARTINSIGHTS}`,
    name: SmartInsightsPathName.SMARTINSIGHTS,
    component: () =>
      import(/* webpackChunkName: "smartinsights-page" */ './pages/SmartInsightsPage.vue'),
  },
]);
